import { render, staticRenderFns } from "./TopBrands.vue?vue&type=template&id=5caec3ef&scoped=true&"
import script from "./TopBrands.vue?vue&type=script&lang=js&"
export * from "./TopBrands.vue?vue&type=script&lang=js&"
import style0 from "./TopBrands.vue?vue&type=style&index=0&id=5caec3ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5caec3ef",
  null
  
)

export default component.exports